<template>
  <div>
    <img @mouseover="onMouseOver" @mouseleave="onMouseLeave" @click="openAlertModal" class="btn" :class="imageStyle" src="/scales.svg" width="20px" alt="Scales Icon">
  </div>
</template>
<script>
import { mapMutations, mapGetters } from 'vuex'
export default {
  name: 'ButtonEvaluate',
  props: {
    payload: {
      type: Object,
      required: true
    },
    imageStyle: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      isFixed: false
    }
  },
  computed: {
    ...mapGetters('modals', ['isModalOpen', 'findModal'])
  },
  methods: {
    openAlertModal (params = {}) {
      this.create({
        designator: 'evaluate-modal',
        component_name: 'ModalEvaluate',
        modal_title: `${this.payload.applicant.full_name} - ${this.payload.position.title} - ${this.payload.position.company.name}`,
        modal_width: 1500,
        is_center_modal: true,
        props: {
          applicant: this.payload.applicant,
          position: this.payload.position
        },
        ...params
      })
    },
    onMouseOver () {
      this.isFixed = false
      this.openAlertModal({ is_center_modal: true })
    },
    onMouseLeave () {
      if (this.isFixed) {
        return
      }
      const modal = this.findModal({ type: 'designator', value: 'evaluate-modal' })
      this.remove(modal)
    },
    getModal () {
      return this.findModal({ type: 'designator', value: 'evaluate-modal' })
    },
    ...mapMutations('modals', ['create', 'remove'])
  }
}
</script>
